/**
 * Ролі користувачів. Менеджерські ролі (склад / шоурум / Директ / закупки) мають ті самі права,
 * що й загальний "manager" — тому перевірки доступу йдуть через MANAGER_ROLES, а не через одну роль.
 * Дублюється на сервері: lib/roles.js.
 */
export const MANAGER_ROLES = [
    "manager",
    "warehouse_manager",
    "showroom_manager",
    "direct_manager",
    "purchase_manager",
];

/** Розділ «Виробництво» (закупки, матеріали, техкарти) закритий для менеджерів, крім менеджера закупок. */
export const PRODUCTION_BLOCKED_MANAGER_ROLES = MANAGER_ROLES.filter((r) => r !== "purchase_manager");

export const isManagerRole = (role) => MANAGER_ROLES.includes(role);

/** Порядок — як у списку вибору ролі. */
export const ROLE_OPTIONS = [
    { value: "admin", label: "Адміністратор" },
    { value: "director", label: "Директор" },
    { value: "warehouse_manager", label: "Менеджер складу" },
    { value: "showroom_manager", label: "Менеджер шоуруму" },
    { value: "direct_manager", label: "Менеджер Директу" },
    { value: "purchase_manager", label: "Менеджер закупок" },
    { value: "finance", label: "Фінансист" },
    { value: "manager", label: "Менеджер (загальний)" },
    { value: "ROP", label: "РОП" },
    { value: "targetolog", label: "Таргетолог" },
    { value: "smm", label: "СММ" },
    { value: "seamstress", label: "Швея" },
    { value: "cutter", label: "Закрійниця" },
];

/** Місто шоуруму для ролі showroom_manager (ті самі ключі, що в чеклісті шоурумів). */
export const SHOWROOM_CITY_OPTIONS = [
    { value: "kyiv", label: "Київ" },
    { value: "kharkiv", label: "Харків" },
];

/** «Менеджер шоуруму (Київ)» — підпис ролі для таблиць. */
export function roleLabel(role, showroomCity) {
    const base = ROLE_OPTIONS.find((r) => r.value === role)?.label || role || "—";
    if (role !== "showroom_manager") return base;
    const city = SHOWROOM_CITY_OPTIONS.find((c) => c.value === showroomCity)?.label;
    return city ? `${base} (${city})` : base;
}
